import { Routes } from '@angular/router';
import { matchSignedInUser } from './auth/signed-in-match';
import { routes as dashboardRoutes } from './pages/dashboard/dashboard.routes';

export const routes: Routes = [
  ...dashboardRoutes,
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./pages/auth-callback/auth-callback').then(
        ({ AuthCallbackPage }) => AuthCallbackPage,
      ),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized').then(({ UnauthorizedPage }) => UnauthorizedPage),
  },
  {
    path: 'sign-in',
    loadComponent: () => import('./pages/signin/signin').then(({ SigninPage }) => SigninPage),
  },
  {
    path: 'sign-out',
    loadComponent: () => import('./pages/signout/signout').then(({ SignoutPage }) => SignoutPage),
  },
  {
    path: '**',
    canMatch: [matchSignedInUser],
    loadComponent: () =>
      import('./pages/dashboard/not-found/not-found').then(
        ({ DashboardNotFoundPage }) => DashboardNotFoundPage,
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found').then(({ NotFoundPage }) => NotFoundPage),
  },
];
